import React, { useContext, useEffect, useState } from "react";
import Heading from "../../../Components/Heading/Heading";
import SelectForm from "../../../Components/SelectForm/SelectForm";
import { getContext } from "../../../Helpers/Context/Context";
import { useNavigate, useLocation } from "react-router-dom";
import { APICall } from "../../../Helpers/API/APICalls";
import moment from "moment";
import DynamicGrid from "../../../Components/DynamicGrid/DynamicGrid";
import { LoaderContext } from "../../../Helpers/Context/Context";
import {
  getCustomers,
  PurchaseOrderFormGirdData,
  ExportToExcelPOForm,
  FileDownload,
} from "../../../Helpers/API/APIEndPoints";
import { Tooltip } from "antd";
import axios from "axios";
import fileDownload from "js-file-download";
import {
  InputLabel,
  Select,
  SelectChangeEvent,
  MenuItem,
  FormControl,
} from "@mui/material";
import { Padding } from "@mui/icons-material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import notify from "../../../Helpers/ToastNotification";

//Created by Prashant
const PurchaseOrderForm = () => {
  const location = useLocation();
  let navigate = useNavigate();
  const { EmployeeId, RoleId } = getContext();
  const [customerOptions, setCustomerOptions] = useState<any>([]);
  const [customerSelectData, setCustomerSelectData] = useState<any>(
    JSON.parse(localStorage.getItem("customerSelectData") || "{}"));   //deepak gupta
  const [POGridData, setPOGridData] = useState<any>([]);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [start, setStart] = useState(0);
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [searchText, setSearchText] = useState("");
  const [count, setCount] = useState(0);
  const { showLoader, hideLoader } = useContext(LoaderContext);
  //const showCustomToolbar = location.state === "true" || location.state === "false";
  const [isactive, setIsActive] = useState("active");
  const [isReset, setIsReset] = useState<any>(false)

  const options = {
    selectableRows: "none",
    count: count,
    rowsPerPage: pageSize,
    serverSide: true,
    rowsPerPageOptions: [],
    download: false,
    print: false,
    viewColumns: false,
    filter: false,
    search: true,

    setCellHeaderProps: () => ({ align: "center" }),

    onChangeRowsPerPage: (num) => {
      //   setLimit(num);
      //   setNxtPgInfo("");
      //   setPrevPgInfo("");
      //   setIsPrevOrNext("");
    },
    onSearchChange: (searchText) => {
      if (searchText !== null) {
        setSearchText(searchText);
        setStart(0);
      } else {
        setSearchText("");
      }
    },
    onColumnSortChange: async (sortColumn, sortDirection) => {
      if (sortDirection === "asc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
      if (sortDirection === "desc") {
        await setSortColumn(sortColumn);
        await setSortDirection(sortDirection);
      }
    },
    onChangePage: async (page) => {
      setStart(page * pageSize);
    },
    // showCustomToolbar ?
    customToolbar: () => {
      return (
        <FormControl sx={{ mt: 1 }}>
          <InputLabel id="demo-simple-select-helper-label">Active</InputLabel>
          <Select
            labelId="demo-simple-select-helper-label"
            id="demo-simple-select-helper"
            label="Active"
            value={isactive}
            onChange={handleChange}
            sx={{
              width: 80,
              height: 30, // Set the desired height
              "&:focus": { color: "success.main" }, // Change text color to green on focus
            }}
          >
            <MenuItem value={"All"}>All</MenuItem>
            <MenuItem value={"active"}>Yes</MenuItem>
            <MenuItem value={"inactive"}>No</MenuItem>
          </Select>
        </FormControl>
      );
    },
  };

  const handleChange = (event: SelectChangeEvent) => {
    setIsActive(event.target.value);
  };

     //deepak gupta
  useEffect(() => {
    localStorage.setItem("customerSelectData",JSON.stringify(customerSelectData));
  }, [customerSelectData]);

  useEffect(() => {

    //deepak gupta
    const clearUnwantedLocalStorage = () => {
      const keysToKeep = ["customerSelectData"];
      Object.keys(localStorage).forEach((key) => {
        if (!keysToKeep.includes(key)) {
          localStorage.removeItem(key);
        }
      });
    };

    (async () => {
      clearUnwantedLocalStorage();   //deepak gupta
      await getCustomer();
    })();
  }, [customerSelectData]);

  useEffect(() => {
    (async () => {
      await getCustomer();
    })();
  }, [customerSelectData]);

  useEffect(() => {
    (async () => {
      await GetPurchaseOrderFormGridData();
    })();
  }, [
    isactive,
    searchText,
    start,
    sortColumn,
    sortDirection,
    page,
    pageSize,
    location.state,
    isReset
  ]);

  const getCustomer = async () => {
    let obj = {};
    if (RoleId.includes(3)) {
      obj = {
        EmpId: Number(EmployeeId),
        RoleId: 3,
      };
    } else if (RoleId.includes(8)) {
      //added by mahesh on 09/10/2024
      obj = {
        EmpId: Number(EmployeeId),
        RoleId: 8,
      };
    } //added by mahesh on 09/10/2024
    else if (RoleId.includes(2)) {
      obj = {
        EmpId: Number(EmployeeId),
        RoleId: 2,
      };
    } else if (RoleId.includes(7)) {
      obj = {
        EmpId: Number(EmployeeId),
        RoleId: 7,
      };
    }

    const { data } = await APICall(getCustomers, "POST", obj);

    if (data != undefined || data != null) {
      let customerArray = [];
      await data.map((customer: any) => {
        let tempObj = {
          value: customer.id,
          label: customer.customer,
        };
        customerArray.push(tempObj);
      });
      setCustomerOptions(customerArray);
    }
  };

  const resetFunc = async () => {
    setIsReset(!isReset)
    setCustomerOptions([]);
    setCustomerSelectData({});
    localStorage.removeItem("engagement");   //deepak gupta
    //await GetPurchaseOrderFormGridData();
  };

  const selectOnChange = async (event: any, apiFieldName: any) => {
    if (apiFieldName === "customer") {
      setCustomerSelectData(event);
    }
  };

  useEffect(() => {
    (async () => {
      await GetPurchaseOrderFormGridData();
    })();
  }, []);

  const GetPurchaseOrderFormGridData = async () => {
    await showLoader();
    let role;

    if (RoleId.includes(3)) {
      role = 3;
    }
    //added by mahesh on 09/10/2024
    else if (RoleId.includes(8)) {
      role = 8;
    } //end
    else if (RoleId.includes(7)) {
      role = 7;
    } else if (RoleId.includes(2)) {
      role = 2;
    }

    let requestParams = {
      EmpId: Number(EmployeeId),
      RoleId: role ? role : null,
      start: start,
      pageSize: pageSize,
      sortColumn: sortColumn === "" ? "CreatedDate" : sortColumn,
      sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      searchText: searchText,
      CustomerId: customerSelectData.value
        ? String(customerSelectData.value)
        : "",
      activeStatusId: isactive,
    };
    const { data } = await APICall(
      PurchaseOrderFormGirdData,
      "POST",
      requestParams
    );

    if (data && data.length > 0) {
      setPOGridData(data);
      setCount(data[0].count);
      await hideLoader();
    } else {
      setPage(0);
      setStart(0);
      setCount(0);
      setPOGridData(data);
      await hideLoader();
    }
  };

  // Added custom color for tooltip
  const customColors = ["#2755f3", "#27ae60"];

  const gridColumns = [
    {
      name: "id",
      label: "Id",
      options: {
        display: false,
        filter: false,
        sort: false,
      },
    },
    {
      name: "customer",
      label: "Customer",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "engagement",
      label: "Engagement",
      options: {
        filter: false,
        sort: true,
        sortDescFirst: true,
      },
    },
    {
      name: "poReceivedDate",
      label: "Received Date",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        customBodyRender: (value) =>
          value ? moment(value).format("DD/MM/YYYY") : "",
      },
    },
    {
      name: "poDate",
      label: "PO Date",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
        customBodyRender: (value) =>
          value ? moment(value).format("DD/MM/YYYY") : "",
      },
    },
    {
      name: "poValue",
      label: "PO Value",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },
    {
      name: "poNumber",
      label: "PO Number",
      options: {
        filter: false,
        sort: false,
        sortDescFirst: true,
      },
    },

    {
      name: "",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          let id = tableMeta.tableData[tableMeta.rowIndex].purchaseOrderId;
          let data = tableMeta.tableData[tableMeta.rowIndex];

          let url = data.fileUrl;
          let customer = data.customer;

          return (
            <>
              <Tooltip title="Edit" color={customColors[0]}>
                <a
                  onClick={(e) => {
                    e.preventDefault();

                    navigate("PurchaseOrderFormEdit", { state: id });
                  }}
                  className="action_icon"
                >
                  <i className="fa fa-pencil" aria-hidden="true"></i>
                </a>
              </Tooltip>
              {url && url ? (
                <>
                  <Tooltip title="Download" color={customColors[1]}>
                    <a
                      onClick={(e) => {
                        e.preventDefault();
                        let reqparam = {
                          FileUrl: url,
                          Customer: customer,
                        };
                        axios
                          .request({
                            responseType: "blob",
                            method: "POST",
                            url: FileDownload,
                            data: reqparam,
                            headers: {
                              "Access-Control-Allow-Origin": "*",
                              "Content-Type": "application/json",
                              "Access-Control-Allow-Headers": "*",
                            },
                          })
                          .then((response) => {
                            const contentDisposition =
                              response.headers["content-disposition"];

                            // Extract the filename using a regular expression
                            const filenameRegex =
                              /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                            const matches =
                              filenameRegex.exec(contentDisposition);

                            let filename = "";
                            if (matches != null && matches[1]) {
                              filename = matches[1].replace(/['"]/g, "");
                            }

                            // Extract the file extension
                            const fileExtension = filename.substring(
                              filename.lastIndexOf(".")
                            );

                            // Use the extracted filename and file extension
                            if (filename == "Doc.aspx") {
                              fileDownload(
                                response.data,
                                `${data.poNumber}-${moment(data.poDate).format(
                                  "DD/MMMM/YYYY"
                                )}.docx`
                              );
                            } else {
                              fileDownload(
                                response.data,
                                `${data.poNumber}-${moment(data.poDate).format(
                                  "DD/MMMM/YYYY"
                                )}.pdf`
                              );
                            }
                            // fileDownload(response.data, `${data.poNumber}-${moment(data.poDate).format('DD/MMMM/YYYY')}${fileExtension}`);
                            //fileDownload(response.data,`${data.poNumber}-${moment(data.poDate).format('DD/MMMM/YYYY')}.docx`);
                          })
                          .catch((error) => {
                            if (error) {
                              notify(
                                1,
                                "File not found or an error occurred during the download."
                              );
                            }
                            console.error(error.response.data);
                          });
                        //navigate("PurchaseOrderFormEdit", { state: id });
                      }}
                      className="action_icon"
                    >
                      <i
                        className="fa-solid fa-download"
                        aria-hidden="true"
                      ></i>
                    </a>
                  </Tooltip>
                </>
              ) : null}
            </>
          );
        },
      },
    },
    {
      name: "isActivess",
      label: "Active",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (value, tableMeta) => {
          if (value == "Yes") {
            return <i className="fas fa-check"></i>;
          } else {
            return <i className="fas fa-times"></i>;
          }
        },
      },
    },
  ];

  const onClickFunction = async (action) => {
    if (action === "submit") {
      showLoader();
      await GetPurchaseOrderFormGridData();
      hideLoader();
    }
  };

  const ExportToExcel = async () => {
    showLoader();
    let role;

    if (RoleId.includes(3)) {
      role = 3;
    } else if (RoleId.includes(7)) {
      role = 7;
    } else if (RoleId.includes(2)) {
      role = 2;
    }

    let requestParams = {
      EmpId: Number(EmployeeId),
      RoleId: role ? role : null,
      start: start,
      pageSize: count,
      sortColumn: sortColumn === "" ? "CreatedDate" : sortColumn,
      sortOrder: sortDirection === "" ? "Desc" : sortDirection,
      searchText: searchText,
      CustomerId: customerSelectData.value
        ? String(customerSelectData.value)
        : "",
      activeStatusId: isactive,
      // pageSize: count,
      // start: start,
      // sortColumn: sortColumn,
      // sortOrder: sortDirection,
      // searchText: searchText,
    };

    axios
      .request({
        responseType: "blob",
        method: "POST",
        url: ExportToExcelPOForm,
        data: requestParams,
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
          "Access-Control-Allow-Headers": "*",
        },
      })
      .then((response) => {
        fileDownload(response.data, "Purchase Order.xlsx");
      })
      .catch((error) => {
        console.error(error.response.data);
      });
    hideLoader();
  };

  const [toggle, setToggle] = useState(false);
  const toggleFilter = () => {
    setToggle(!toggle);
  };

  return (
    <>
      <Heading title={"Purchase Order"} />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-12">
            <div className="d-flex justify-content-between">
              <div>
                <button
                  onClick={() => navigate("PurchaseOrderFormEdit")}
                  className="btn btn-update"
                >
                  Create
                </button>
              </div>
              <div className="d-flex gap-2">
                <button
                  onClick={() => ExportToExcel()}
                  className="btn btn-export"
                >
                  Export to Excel
                </button>
                <a className="filterIcon" onClick={toggleFilter}>
                  <i className="fa fa-filter"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="col-lg-12">
            {toggle && (
              <div className="row mt-3" id="filterContent">
                <div className="col-lg-4 col-md-4 col-sm-6">
                  <div className="form-group">
                    <label>Select Customer</label>
                    <SelectForm
                      options={customerOptions}
                      placeholder="Select Customer"
                      value={
                        Object.keys(customerSelectData).length !== 0
                          ? customerSelectData
                          : ""
                      }
                      onChange={(event) => selectOnChange(event, "customer")}
                      isMulti={false}
                      noIndicator={false}
                      noSeparator={false}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="d-flex justify-content-end gap-2">
                    <button onClick={() => resetFunc()} className="btn btn-reset">
                      Reset
                    </button>
                    <button
                      onClick={() => onClickFunction("submit")}
                      className="btn btn-submit"
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="col-lg-12 mt-3">
            <DynamicGrid
              options={options}
              data={POGridData}
              columns={gridColumns}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default PurchaseOrderForm;
